import axios from "axios"
import library from "../../../utils/Library"

export const pushProcessLogEventLogger = async (body) => {
  const TOKEN = sessionStorage.getItem("token")
  const URL =
    library.getBaseAPIUrl("eventslog_push") + "/pushProcessLogEventLogger"

  await axios({
    url: URL,
    method: "POST",
    data: body,
    headers: {
      Authorization: `Bearer ${TOKEN}`,
    },
  })
}
